export default {
  appName: 'Management System',
  yes: 'Yes',
  no: 'No',
  search: 'Search',
  reset: 'Reset',
  cancel: 'Cancel',
  close: 'Close',
  confirm: 'Confirm',
  save: 'Save',
  edit: 'Edit',
  detail: 'Details',
  copy: 'Copy',
  delete: 'Delete',
  actions: 'Actions',
  emptyDash: '—',
  adminFallback: 'Admin',
  comingSoon: 'Coming soon',
  refresh: 'Refresh',
  more: 'More'
}
